import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";
import {InternalChatUsersListFilters} from "@dropDesk/domain/entities/internal_chat/internal_chat_users_list_filters";

@injectable()
export class ListInternalChatUsersUseCase {
  private _repository: InternalChatRepository;

  constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
    this._repository = repository;
  }

  public call(filters: InternalChatUsersListFilters): Promise<ListPaginationEntity<InternalChatUserEntity>> {
    return this._repository.listUsers(filters);
  }
}
